<template>
  <div id="idex" ref="idex"></div>
</template>

<style >
  @import '../../assets/css/gojs/LightBoxContextMenu.css';
  .fa-numeric-1:before{
    content: "1";
    font-family: 'Open Sans';
  }
  .fa-numeric-2:before{
    content: "2";
    font-family: 'Open Sans';
  }
  .fa-numeric-3:before{
    content: "3";
    font-family: 'Open Sans';
  }
  .fa-numeric-4:before{
    content: "4";
    font-family: 'Open Sans';
  }
  .fa-numeric-5:before{
    content: "5";
    font-family: 'Open Sans';
  }
  .fa-numeric-6:before{
    content: "6";
    font-family: 'Open Sans';
  }
  .fa-numeric-7:before{
    content: "7";
    font-family: 'Open Sans';
  }
  .fa-numeric-8:before{
    content: "8";
    font-family: 'Open Sans';
  }
  .fa-numeric-9:before{
    content: "9";
    font-family: 'Open Sans';
  }
  #iconSelected .table-icons .btn{
    min-height: 30px;
    min-width: 30px;
    text-align: center;
    padding: 0;
    margin: 1px;
  }
  #iconSelected .table-icons td {
    min-width: 30px;
  }
  #iconSelected .btn-icon-selected {
    background-color: #ea6557;
    border-color: #ea6557;
    color: #fff;
  }
</style>
<script>

import 'gojs/release/go'
import {icons} from '../../assets/scripts/gojs/icons'
import 'jquery-simplecolorpicker/jquery.simplecolorpicker'
import 'jquery-simplecolorpicker/jquery.simplecolorpicker.css'
import 'bootstrap-iconpicker/bootstrap-iconpicker/css/bootstrap-iconpicker.min.css'
import 'bootstrap-iconpicker/bootstrap-iconpicker/js/bootstrap-iconpicker.min'

let $ = go.GraphObject.make

export default {
  components: {},
  name: 'BiblioGoJS',
  props: {
    content: {
      require: true
    },
    modal: {
      require: true
    },
    modalWiki: {
      require: true
    },
    modalDocuments: {
      require: true
    },
    menu: {
      require: true
    },
    editable: {
      default: true
    }
  },
  data: function () {
    return {
      diagram: null,
      contextMenu: null,
      diagramData: {},
      scale: 0,
      biblioContent: null,
      promptSummarize: 'The task is to generate a condensed overview of a collection of titles and abstracts. The summary should begin by outlining the primary aim and objectives of the study. Following this, it should detail the key findings achieved in a paragraph format. The conclusion should discuss further research possibilities and potential new applications. The text of the summary should be written in straightforward, non-technical language, and it should include a few references formatted as (Last name, date). The summary should be titled "Tree Structure Summary. \n \n',
      colors: {
        blue: '#00B5CB',
        orange: '#F5AA35',
        orange2: '#F47321',
        green: '#C8DA2B',
        gray: '#888',
        white: '#F5F5F5',
        violet: '#cf25cf'
      },
      menuActions: [{
        text: 'Copy',
        shortened: 'Ctrl+C'
      }, {
        text: 'Cut',
        shortened: 'Ctrl+X'
      }, {
        text: 'Delete',
        shortened: 'Delete'
      }, {
        text: 'Paste',
        shortened: 'Ctrl+V'
      }, {
        text: 'Select All',
        shortened: 'Ctrl+A'
      }, {
        text: 'Undo',
        shortened: 'Ctrl+Z'
      }, {
        text: 'Redo',
        shortened: 'Ctrl+Y'
      }, {
        text: 'Scroll To Part',
        shortened: ''
      }, {
        text: 'Zoom To Fit',
        shortened: 'Ctrl++'
      }, {
        text: 'Reset Zoom',
        shortened: 'Ctrl--'
      }, {
        text: 'Group Selection',
        shortened: 'Select'
      }, {
        text: 'Ungroup Selection',
        shortened: 'Left Click'
      }, {
        text: 'Summarize',
        shortened: 'Ctrl+R'
      }, {
        text: 'Summarize Selected Box(es)',
        shortened: 'Ctrl+M'
      }
      ],
      icons: ['', 'lightbulb', 'eye', 'exclamation-triangle', 'exclamation-circle', 'question-circle', 'check-square', 'times-circle', 'smile', 'frown', 'meh', 'euro-sign',
        'numeric-1', 'numeric-2', 'numeric-3', 'numeric-4', 'numeric-5', 'numeric-6', 'numeric-7', 'numeric-8', 'numeric-9']
      //   'minus-circle', 'award', 'bomb', 'check', 'times', 'info-circle', 'exclamation', 'search-location', 'thumbs-down', 'thumbs-up', 'traffic-light', 'copyright', 'crown', 'fighter-jet', 'play', 'pause', 'stop', 'flask', 'bell', 'lock-open', 'lock', 'question-circle', 'star', 'ban', 'cloud', 'euro-sign', 'dollar-sign', 'handshake', 'history', 'oil-can', 'clock', 'heart', 'hourglass-half', 'recycle']
    }
  },
  beforeMount () {
    go.licenseKey = process.env.GOJS_LICENSEKEY
    this.biblioContent = (typeof this.content !== 'undefined') ? this.content : this.biblioContent
  },
  mounted: function () {
    this.init()

    for (let k in icons) {
      icons[k] = go.Geometry.fillPath(icons[k])
    }

    let myDiagram =
        $(go.Diagram, this.$refs.idex, {
          initialContentAlignment: go.Spot.Center,
          // make sure users can only create trees
          validCycle: go.Diagram.CycleDestinationTree,
          // users can select only one part at a time
          //  maxSelectionCount: 1,
          initialAutoScale: go.Diagram.Uniform,
          scale: this.scale,
          layout: $(go.TreeLayout, {
            treeStyle: go.TreeLayout.StyleLastParents,
            arrangement: go.TreeLayout.ArrangementHorizontal,
            // properties for most of the tree:
            angle: 90,
            layerSpacing: 35,
            // properties for the "last parents":
            alternateAngle: 90,
            alternateLayerSpacing: 35,
            alternateAlignment: go.TreeLayout.AlignmentBus,
            alternateNodeSpacing: 20,
            sorting: go.TreeLayout.SortingAscending,
            comparer: function (a, b) {
              if (a.node.data.loc && b.node.data.loc) {
                let locA = a.node.data.loc.split(' ')
                let locB = b.node.data.loc.split(' ')
                var ay = locA[0] ? parseInt(locA[0]) : 0
                var by = locB[0] ? parseInt(locB[0]) : 0
              }
              if (isNaN(ay) || isNaN(by)) return 0
              if (ay < by) return -1
              if (ay > by) return 1
              return 0
            }
          }),
          // support editing the properties of the selected person in HTML
          'ChangedSelection': this.onSelectionChanged,
          'grid.visible': false,
          'TextEdited': (e) => {
            this.update()
          },
          'ModelChanged': (e) => {
            if (e.isTransactionFinished && e.oldValue !== 'Initial Layout') {
              this.update()
            }
          },
          'SelectionMoved': () => {
            this.diagram.selection.each(n => n.invalidateLayout())
          },
          // allow double-click in background to create a new node
          'clickCreatingTool.archetypeNodeData': {
            text: 'New keyword',
            color: '#34495e',
            name: '(new keyword)',
            title: '',
            key: Math.random().toString(36).substr(2, 9),
            searched: false,
            summarize: '',
            summarizeNodes: '',
            geo_search: 'search',
            geo_edit: 'edit',
            isExpanded: true
          },
          // enable undo & redo
          'undoManager.isEnabled': true
        })

    myDiagram.model.isReadOnly = !this.editable
    myDiagram.isReadOnly = !this.editable
    myDiagram.layout.commitNodes = function () {
      go.TreeLayout.prototype.commitNodes.call(myDiagram.layout)
    }

    myDiagram.nodeTemplate =
        $(go.Node, 'Auto', {
          selectionAdorned: true,
          resizable: true,
          isTreeExpanded: true,
          locationSpot: go.Spot.Center,
          contextMenu: this.contextMenu,
          minSize: new go.Size(160, 80),
          click: (e, obj) => {
            this.commandItemMenu('Scroll To Part')(null)
            var diagram = obj.diagram
            diagram.startTransaction('select descendants')
            diagram.clearSelection()
            obj.isSelected = true
            this.selectDescendants(obj.part)
            diagram.commitTransaction('select descendants')
          },
          doubleClick: this.nodeDoubleClick,
          mouseDragEnter: (e, node, prev) => {
            let diagram = node.diagram
            let selnode = diagram.selection.first()
            if (!this.mayWorkFor(selnode, node)) {
              return
            }
            let shape = node.findObject('SHAPE')
            if (shape) {
              shape._prevFill = shape.fill // remember the original brush
              shape.fill = 'darkred'
            }
          },
          mouseDragLeave: (e, node, next) => {
            let shape = node.findObject('SHAPE')
            if (shape && shape._prevFill) {
              shape.fill = shape._prevFill // restore the original brush
            }
          },
          mouseDrop: (e, node) => {
            let diagram = node.diagram
            let selnode = diagram.selection.first() // assume just one Node in selection
            if (this.mayWorkFor(selnode, node)) {
              // find any existing link into the selected node
              let link = selnode.findTreeParentLink()
              if (link !== null) { // reconnect any existing link
                link.fromNode = node
              } else { // else create a new link
                diagram.toolManager.linkingTool.insertLink(node, node.port, selnode, selnode.port)
              }
            }
          },
          toolTip: this.nodeTooltip()
        },
          // for sorting, have the Node.text be the data.name
        new go.Binding('text', 'name'),
          // bind the Part.layerName to control the Node's layer depending on whether it isSelected
        new go.Binding('layerName', 'isSelected', (sel) => { return sel ? 'Foreground' : '' }).ofObject(),
          // define the node's outer shape
        new go.Binding('isTreeExpanded', 'isExpanded', (isExpanded) => { return isExpanded }),
        new go.Binding('position', 'loc', (loc, go) => { return loc || go.Point.parse }).makeTwoWay(go.Point.stringify),
        $(go.Shape, 'Rectangle', {
          name: 'SHAPE',
          stroke: null,
          figure: 'RoundedRectangle',
          // set the port properties:
          portId: '',
          fromLinkable: true,
          toLinkable: true,
          cursor: 'pointer'
        }, new go.Binding('fill', 'color', (v) => { return (v === '#888888') ? '#34495e' : v })),
        $(go.Panel, 'Auto',
          // define the panel where the text will appear
          this.tablePanel()
        ), // end Horizontal Panel
        this.nodeCollapse()
        )

    myDiagram.linkTemplate =
        $(go.Link, go.Link.Orthogonal, {
          corner: 5,
          selectable: true,
          relinkableFrom: true,
          relinkableTo: true
        }, $(go.Shape, {
          stroke: '#00a7df',
          strokeWidth: 5
        }))

    myDiagram.contextMenu = this.contextMenu // window.myHTMLLightBox is defined in extensions/lightbox.js

    this.diagram = myDiagram
    this.updateModel(this.diagramData)
  },
  watch: {
    biblioContent: function (val) {
      this.init()
      this.updateModel(this.diagramData)
    },
    content: function (val) {
      this.biblioContent = val
    }
  },
  methods: {
    init: function () {
      if (this.biblioContent !== null) {
        let content = JSON.parse(this.biblioContent)
        let keys = Object.keys(content)
        let array = []
        for (let key in keys) {
          array.push(content[keys[key]])
        }
        this.diagramData = go.Model.fromJson('{ "class": "go.TreeModel","nodeDataArray":' + JSON.stringify(array) + '}')
      } else {
        this.diagramData = go.Model.fromJson('{ "class": "go.TreeModel","nodeDataArray":' + JSON.stringify([]) + '}')
      }

      this.contextMenu = $(go.HTMLInfo, {
        show: this.showContextMenu,
        hide: this.hideContextMenu
      })
      setTimeout(() => {
        this.$emit('initiated', true)
      }, 500)
    },
    commandItemMenu: function (name) {
      return (event) => {
        switch (name) {
          case 'Copy':
            this.diagram.commandHandler.copySelection()
            break
          case 'Cut':
            this.diagram.commandHandler.cutSelection()
            break
          case 'Delete':
            this.diagram.commandHandler.deleteSelection()
            break
          case 'Paste':
            this.diagram.commandHandler.pasteSelection(this.diagram.lastInput.documentPoint)
            break
          case 'Select All':
            this.diagram.commandHandler.selectAll()
            break
          case 'Undo':
            this.diagram.commandHandler.undo()
            break
          case 'Redo':
            this.diagram.commandHandler.redo()
            break
          case 'Scroll To Part':
            this.diagram.commandHandler.scrollToPart()
            break
          case 'Zoom To Fit':
            this.diagram.commandHandler.zoomToFit()
            break
          case 'Reset Zoom':
            this.diagram.commandHandler.resetZoom()
            break
          case 'Group Selection':
            this.diagram.commandHandler.groupSelection()
            break
          case 'Ungroup Selection':
            this.diagram.commandHandler.ungroupSelection()
            break
          case 'Summarize':
            let selnode = this.diagram.selection.first()
            this.summarize(selnode.data)
            break
          case 'Summarize Selected Box(es)':
            let selnode1 = this.diagram.selection.first()
            let selectedNodes = []
            this.diagram.selection.iterator.each(function (node) {
              selectedNodes.push(node)
            })
            this.summarizeAll(selectedNodes, selnode1.data)
            break
        }
        this.menu.style.display = 'none'

        if (event !== null) {
          event.preventDefault()
        }
      }
    },
    isVisibleItemMenu: function (name) {
      return (diagram) => {
        switch (name) {
          case 'Copy':
            return diagram.commandHandler.canCopySelection()
          case 'Cut':
            return diagram.commandHandler.canCutSelection()
          case 'Delete':
            return diagram.commandHandler.canDeleteSelection()
          case 'Paste':
            return diagram.commandHandler.canPasteSelection()
          case 'Select All':
            return diagram.commandHandler.canSelectAll()
          case 'Undo':
            return diagram.commandHandler.canUndo()
          case 'Redo':
            return diagram.commandHandler.canRedo()
          case 'Scroll To Part':
            return diagram.commandHandler.canScrollToPart()
          case 'Zoom To Fit':
            return diagram.commandHandler.canZoomToFit()
          case 'Reset Zoom':
            return diagram.commandHandler.canResetZoom()
          case 'Group Selection':
            return diagram.commandHandler.canGroupSelection()
          case 'Ungroup Selection':
            return diagram.commandHandler.canUngroupSelection()
          case 'Summarize':
            let selnode = diagram.selection.first()
            let nb = diagram.selection.iterator.count
            return nb === 1 && selnode.data.documents
          case 'Summarize Selected Box(es)':
            let nb2 = diagram.selection.iterator.count
            return nb2 > 1
        }
      }
    },
    showContextMenu: function (obj, diagram, tool) {
      this.menu.actions = []
      this.menuActions.forEach((action) => {
        let command = this.commandItemMenu(action.text)
        let isVisible = this.isVisibleItemMenu(action.text)

        if ((typeof command === 'function') && typeof isVisible === 'function' && isVisible(diagram)) {
          this.menu.actions.push({text: action.text, command: command, shortened: action.shortened})
        }
      })

      let mousePt = diagram.lastInput.viewPoint

      this.menu.style.top = (60 + mousePt.y).toString() + 'px'
      this.menu.style.left = (35 + mousePt.x).toString() + 'px'
      this.menu.style.display = 'block'
    },
    hideContextMenu: function (event) {
      this.menu.style.display = 'none'
    },
    update: function (loadModel = true) {
      if (this.editable === true) {
        this.scale = this.diagram.scale

        let json = this.diagram.model.toJson()

        json = JSON.parse(json)

        let content = {}
        json.nodeDataArray.forEach((node) => {
          if (node.summarize === 'undefined') {
            node.summarize = ''
          }
          if (node.summarizeNodes === 'undefined') {
            node.summarizeNodes = ''
          }
          content[node.key] = node
        })

        let newVal = JSON.stringify(content)

        this.$emit('updateBiblioContent', newVal)
      }
    },
    upload: function () {
      return new Promise((resolve, reject) => {
        if (this.modal.uploadFiles && this.modal.uploadFiles.length !== 0) {
          let data = new FormData()

          this.modal.uploadFiles.forEach((file) => {
            if (!file.link) {
              data.append('files[]', file)
            }
          })
          data.append('target', 'biblio_file')
          data.append('additional_path', this.$auth.user().id)

          this.axios.post('/files/', data).then((response) => {
            this.modal.uploadFiles.forEach((file, key) => {
              if (typeof response.data.files[file.name] !== 'undefined') {
                this.modal.uploadFiles[key] = Object.assign({}, this.modal.uploadFiles[key])
                this.modal.uploadFiles[key].link = response.data.path + response.data.files[file.name]
                this.modal.uploadFiles[key].addedAt = this.$moment()
                this.modal.uploadFiles[key].addedBy = {'id': this.$auth.user().id, 'firstName': this.$auth.user().firstName, 'lastName': this.$auth.user().lastName}
              }
            })
            resolve(response)
          }).catch((error) => {
            if (typeof error.response !== 'undefined') {
              if (error.response.status === 413) {
                this.$notify({
                  type: 'danger',
                  title: 'An error has occurred, max upload size is 10 Mo',
                  placement: 'bottom-right'
                })
              } else {
                let errors = error.response.data.errors
                switch (error.response.data.code) {
                  case 1:
                    this.modal.errorFiles = errors['files'][0]
                    break
                }
              }
            }
            reject(error)
          })
        } else {
          resolve(null)
        }
      })
    },
    model: function () { return this.diagram.model },
    updateModel: function (val) {
      if (val instanceof go.Model) {
        this.diagram.model = val
      } else {
        let m = new go.GraphLinksModel()
        if (val) {
          for (let p in val) {
            m[p] = val[p]
          }
        }
        this.diagram.model = m
      }
    },
    onSelectionChanged: function (event) {
    },
    onTextEdited: function (event) {
      let tb = event.subject
      if (tb === null || (!tb.name && tb.name !== '')) {
        return
      }
      let node = tb.part
      let _key = node.data.key
      if (!isNaN(_key)) {
        node.data.key = node.data.name
      }
      this.update()
    },
    importJson: function (json) {
      this.biblioContent = json

      setTimeout(() => {
        this.diagram.startTransaction('import json')
        this.diagram.commitTransaction('import json')
      }, 500)
    },
    nodeDoubleClick: function (e, obj) {
      let clicked = obj.part
      if (clicked !== null) {
        let thisemp = clicked.data
        this.diagram.startTransaction('add employee')
        let nextkey = (this.diagram.model.nodeDataArray.length + 1).toString()
        let newemp = { key: nextkey, name: '(new keyword)', title: '', parent: thisemp.key, 'searched': false, summarize: '', summarizeNodes: '', 'geo_search': 'search', 'geo_edit': 'edit', 'color': '#34495e' }
        this.diagram.model.addNodeData(newemp)
        this.diagram.commitTransaction('add employee')
      }
    },
    textStyle: function () {
      return { font: '9pt  Segoe UI,sans-serif', stroke: 'white' }
    },
    geoFunc: function (geoname) {
      if (icons[geoname]) return icons[geoname]
      else return icons['heart'] // default icon
    },
    diagramResize: function () {
      if (typeof this.diagram !== 'undefined' && this.diagram !== null) {
        this.diagram.requestUpdate() // Needed!
        this.diagram.contentAlignment = go.Spot.Center
        this.diagram.initialAutoScale = go.Diagram.Uniform
        this.diagram.commandHandler.resetZoom()
      }
    },
    mayWorkFor: function (node1, node2) {
      if (!(node1 instanceof go.Node)) {
        return false
      } // must be a Node
      if (node1 === node2) {
        return false
      } // cannot work for yourself
      if (node2.isInTreeOf(node1)) {
        return false
      } // cannot work for someone who works for you

      return true
    },
    addKeyword: function (keyword, document = null, commentAichat = null) {
      return new Promise((resolve) => {
        if (document) {
          this.addDocumentToBiblio(document, keyword)
        } else {
          let url = '/search/datas/' + encodeURI(keyword)
          let keywordID = keyword.replace(/(\r\n|\n|\r|\s)/gm, '').replace(/[\.,'-\/#!?|$%\^"&\*;:{><}=\-_`~()]/g, '')
          this.diagram.startTransaction('make new node')
          this.diagram.model.addNodeData({
            key: keywordID,
            name: keyword,
            title: '',
            searched: false,
            summarize: '',
            summarizeNodes: '',
            url: url,
            comment: commentAichat ? commentAichat : '',
            parent: '',
            geo_search: 'search',
            geo_edit: 'edit',
            color: '#34495e'})
          this.diagram.commitTransaction('make new node')
          this.$salesMachine.addKeywordToBiblio({keyword: keyword})
        }
        resolve()
      })
    },
    initDocumentsModal: function (e, obj, type = 'scienceDoc') {
      jQuery(($) => {
        let data = obj.part.data

        this.modalDocuments.title = data.name
        this.modalDocuments.documents = data.documents
        this.modalDocuments.documents = $.map(data.documents, (value, index) => { return [value] })
        this.modalDocuments.box = []
        this.modalDocuments.type = type
        this.modal.uploadFiles = data.uploadFiles
        this.modal.uploadFiles = $.map(data.uploadFiles, (value, index) => { return [value] })

        this.diagram.nodes.each((node) => {
          if (node.data.name !== data.name) {
            this.modalDocuments.box.push({name: node.data.name, key: node.data.key})
          }
        })

        if (this.modalDocuments.box.length !== 0) {
          this.modalDocuments.box.sort((box1, box2) => {
            let textA = box1.name.toUpperCase()
            let textB = box2.name.toUpperCase()
            return (textA < textB) ? -1 : (textA > textB) ? 1 : 0
          })
        }

        $('#modalDocuments').modal('show')
        $('#modalDocuments .nav-tabs a[href="#' + type + 'sTab"]').tab('show')
        $('#modalDocuments').on('shown.bs.modal', () => {
          $('.note-toolbar-wrapper').removeAttr('style')
          $('.note-toolbar').removeAttr('style')
        })
        $(document).off('click', '.modalDocumentCopy')
        $(document).on('click', '.modalDocumentCopy', (event) => {
          event.preventDefault()
          let documentId = parseInt(event.target.dataset.id)
          let targetBox = event.target.dataset.targetbox

          let document = Object.values(data.documents).find((tmpDocument) => {
            return tmpDocument.id === documentId
          })

          let documents = {}
          let targetNode = {}
          this.diagram.nodes.each((node) => {
            if (node.data.key === targetBox) {
              targetNode = node

              if (typeof node.data.documents === 'undefined' || node.data.documents.length === 0) {
                documents = {}
              } else {
                documents = node.data.documents
              }
              documents[document.id] = document
            }
          })

          let model = this.diagram.model
          // all model changes should happen in a transaction
          model.startTransaction('modified documents')
          model.setDataProperty(targetNode.data, 'documents', Object.assign({}, documents))
          model.commitTransaction('modified documents')
        })
        $(document).off('click', '.modalDocumentSave')
        $(document).on('click', '.modalDocumentSave', (event) => {
          event.preventDefault()
          let documentId = parseInt(event.target.dataset.id)

          let documentToSave = this.modalDocuments.documents.find((document) => {
            return document.id === documentId
          })

          let documents = data.documents

          if (typeof documentToSave !== 'undefined') {
            Object.keys(data.documents).forEach((id) => {
              if (parseInt(id) === documentId) {
                data.documents[documentId].abstract = documentToSave.abstract
                documents = data.documents
              }
            })

            let model = this.diagram.model

            model.startTransaction('save document')
            model.setDataProperty(data, 'documents', documents)
            model.commitTransaction('save document')
          }
        })
        $(document).off('click', '.modalDocumentRemove')
        $(document).on('click', '.modalDocumentRemove', (event) => {
          event.preventDefault()
          let documentId = parseInt(event.target.dataset.id)

          let documents = {}
          let targetNode = {}

          this.diagram.nodes.each((node) => {
            if (node.data.key === data.key) {
              targetNode = node

              documents = this.modalDocuments.documents.filter((document) => {
                return document.id !== documentId
              })
              this.modalDocuments.documents = documents
            }
          })

          let model = this.diagram.model
          // all model changes should happen in a transaction
          model.startTransaction('modified documents')
          model.setDataProperty(targetNode.data, 'documents', documents)
          model.commitTransaction('modified documents')
        })
        $(document).off('click', '.modalDocumentMove')
        $(document).on('click', '.modalDocumentMove', (event) => {
          event.preventDefault()

          let documentId = parseInt(event.target.dataset.id)
          let documentType = event.target.dataset.type
          let documents = data.documents

          Object.keys(data.documents).forEach((id) => {
            if (parseInt(id) === documentId) {
              data.documents[documentId].type = documentType && (documentType === 'patents' || documentType === 'company') ? 'author' : 'patents'
              documents = data.documents
            }
          })

          this.modalDocuments.documents = $.map(data.documents, (value, index) => { return [value] })

          let model = this.diagram.model
          // all model changes should happen in a transaction
          model.startTransaction('change document type')
          model.setDataProperty(data, 'documents', documents)
          model.commitTransaction('change document type')
        })
        $(document).off('click', '.verrouTechnoLockIn')
        $(document).on('click', '.verrouTechnoLockIn', (event) => {
          event.preventDefault()
          let documentId = parseInt(event.target.dataset.id)
          let documents = data.documents
          let document = Object.values(data.documents).find((tmpDocument) => {
            return tmpDocument.id === documentId
          })
          let docAbstract = (document.abstract).replace(/<\/?[^>]+(>|$)/g, '').replace(/\\/g, ' ').replace(/\//g, ' ').replace(/!@#$^&%*|;()+=-[]\/{}|:<>?,–./g, ' ')
          let docTitle = (document.title).replace(/<\/?[^>]+(>|$)/g, '').replace(/\\/g, ' ').replace(/\//g, ' ').replace(/!@#$^&%*|;()+=-[]\/{}|:<>?,–./g, ' ')
          let queryPrompt = 'extract from the title and abstract of a scientific or technological paper the problems(s) or issue(s) to be solved  explicitely mentioned in the technology or the scientific work reported in the paper Report the problem(s) in the form of bullet points. The bullet points must be exactly quoting word-for-word the problem(s), issue(s), challenge(s) or solution(s) mentioned in the title or the abstract. If no problem(s), issue(s) or challenge(s) can be extracted, write "no explicit problem mentioned in the text". \n' +
            'Paper Title : ' + docTitle + '\n' + 'Paper Abstract : ' + docAbstract + '\n' +
            'Question:  extract from the title and abstract of the following paper the problems mentioned :\n'
          this.axios.post('/search/chatai/prompt', {prompt: queryPrompt})
            .then((response) => {
              if (response.data) {
                let TechnoLockIn = response.data.aichat
                if (TechnoLockIn) {
                  Object.values(data.documents).forEach((doc, key) => {
                    if (parseInt(doc.id) === document.id) {
                      if (data.documents[key]) {
                        data.documents[key].technoLockIn = TechnoLockIn
                      } else if (data.documents[doc.id]) {
                        data.documents[doc.id].technoLockIn = TechnoLockIn
                      }
                      documents = data.documents
                    }
                  })

                  this.modalDocuments.documents = $.map(data.documents, (value, index) => { return [value] })

                  let model = this.diagram.model
                  // all model changes should happen in a transaction
                  model.startTransaction('change document technoLockIn')
                  model.setDataProperty(data, 'documents', documents)
                  model.commitTransaction('change document technoLockIn')
                }
              }
            })
            .catch((_error) => {
              this.$notify({
                type: 'warning',
                title: 'Error with tech/sci problem extraction',
                placement: 'bottom-right'
              })
            })
        })
        $(document).off('click', '.uploadExternalFile')
        $(document).on('click', '.uploadExternalFile', (event) => {
          event.preventDefault()
          let node = obj.part
          let fileToUpload = 0
          this.modal.uploadFiles.forEach((file) => {
            if (!file.link) {
              fileToUpload++
            }
          })
          if (fileToUpload) {
            this.upload().then((response) => {
              let model = this.diagram.model
              model.startTransaction('upload file to  box')
              model.setDataProperty(node.data, 'uploadFiles', Object.assign({}, this.modal.uploadFiles))
              model.commitTransaction('upload file to box')
              this.initDocumentsModal(e, obj, type)
            })
          }
        })
        $(document).off('click', '.modalFileRemove')
        $(document).on('click', '.modalFileRemove', (event) => {
          event.preventDefault()
          let node = obj.part
          let fileIndex = parseInt(event.target.dataset.id)
          this.modal.uploadFiles.splice(fileIndex, 1)

          let model = this.diagram.model
          model.startTransaction('remove file from  box')
          model.setDataProperty(node.data, 'uploadFiles', Object.assign({}, this.modal.uploadFiles))
          model.commitTransaction('remove file from  box')
        })

        $(document).off('click', '.modalFileCopy')
        $(document).on('click', '.modalFileCopy', (event) => {
          event.preventDefault()
          let fileIndex = parseInt(event.target.dataset.id)
          let targetBox = event.target.dataset.targetbox
          let file = []

          let files = {}
          let targetNode = {}
          this.diagram.nodes.each((node) => {
            if (node.data.key === targetBox) {
              targetNode = node
              if (typeof node.data.uploadFiles === 'undefined' || node.data.uploadFiles.length === 0) {
                files = {}
              } else {
                files = node.data.uploadFiles
              }
            }
          })
          file[Object.keys(files).length] = this.modal.uploadFiles[fileIndex]
          let model = this.diagram.model
          model.startTransaction('modified uploadFiles')
          model.setDataProperty(targetNode.data, 'uploadFiles', Object.assign(files, file))
          model.commitTransaction('modified uploadFiles')
        })
      })
    },
    exportImage: function () {
      let svg = this.diagram.makeImage({
        background: 'white',
        type: 'image/jpeg',
        maxSize: new go.Size(Infinity, Infinity),
        scale: 1
      })

      let imageData = atob(svg.src.split(',')[1])

      // Use typed arrays to convert the binary data to a Blob
      let arraybuffer = new ArrayBuffer(imageData.length)
      let view = new Uint8Array(arraybuffer)
      for (let i = 0; i < imageData.length; i++) {
        view[i] = imageData.charCodeAt(i) & 0xff
      }
      let blob
      try {
        // This is the recommended method:
        blob = new Blob([arraybuffer], {type: 'application/octet-stream'})
      } catch (e) {
        // The BlobBuilder API has been deprecated in favour of Blob, but older
        // browsers don't know about the Blob constructor
        // IE10 also supports BlobBuilder, but since the `Blob` constructor
        //  also works, there's no need to add `MSBlobBuilder`.
        let bb = new (window.WebKitBlobBuilder || window.MozBlobBuilder)()
        bb.append(arraybuffer)
        blob = bb.getBlob('application/octet-stream') // <-- Here's the Blob
      }

      return blob
    },
    getAllTechnoLockIn: function () {
      this.$notify({
        title: 'Extracting all Tech / Sci problems from biblio',
        icon: 'fa fa-refresh pe-spin pe-7s',
        duration: 20000,
        placement: 'bottom-right'
      })

      let model = this.diagram.model
      let documentSearchAllTech = []

      this.diagram.nodes.each((node) => {
        if (node.data.documents) {
          Object.values(node.data.documents).forEach((document) => {
            if (!document.technoLockIn) {
              let docAbstract = (document.abstract).replace(/<\/?[^>]+(>|$)/g, '').replace(/\\/g, ' ').replace(/\//g, ' ').replace(/!@#$^&%*|;()+=-[]\/{}|:<>?,–./g, ' ')
              let docTitle = (document.title).replace(/<\/?[^>]+(>|$)/g, '').replace(/\\/g, ' ').replace(/\//g, ' ').replace(/!@#$^&%*|;()+=-[]\/{}|:<>?,–./g, ' ')
              let queryPrompt = 'extract from the title and abstract of a scientific or technological paper the problems(s) or issue(s) to be solved  explicitely mentioned in the technology or the scientific work reported in the paper Report the problem(s) in the form of bullet points. The bullet points must be exactly quoting word-for-word the problem(s), issue(s), challenge(s) or solution(s) mentioned in the title or the abstract. If no problem(s), issue(s) or challenge(s) can be extracted, write "no explicit problem mentioned in the text". \n' +
                'Paper Title : ' + docTitle + '\n' + 'Paper Abstract : ' + docAbstract + '\n' +
                'Question:  extract from the title and abstract of the following paper the problems mentioned :\n'
              documentSearchAllTech.push({'docId': document.id, 'query': queryPrompt})
            }
          })
        }
      })

      if (documentSearchAllTech.length !== 0) {
        documentSearchAllTech.forEach((doc, index) => {
          let modulo = index % this.$proxies2.length
          let domain = this.$proxies2[modulo]
          if (doc.query) {
            this.$requestStack.add('post', domain + '/search/chatai/prompt', {prompt: doc.query}, 3)
              .then((response) => {
                if (response.data) {
                  let TechnoLockIn = response.data.aichat
                  if (TechnoLockIn) {
                    this.diagram.nodes.each((node) => {
                      if (node.data.documents) {
                        Object.keys(node.data.documents).forEach((id) => {
                          if (parseInt(id) === doc.docId) {
                            node.data.documents[doc.docId].technoLockIn = TechnoLockIn
                          }
                        })
                        // all model changes should happen in a transaction
                        model.setDataProperty(node.data, 'documents', node.data.documents)
                      }
                    })
                  }
                  let exctatNb = index + 1
                  this.$notify({
                    type: 'success',
                    title: 'Extracting all Tech / Sci problems from biblio : ' + exctatNb + '/' + documentSearchAllTech.length,
                    placement: 'bottom-right'
                  })
                  model.startTransaction('modified documents - add Tech / Sci problems')
                  model.commitTransaction('modified documents - add Tech / Sci problems')
                }
              })
              .catch((_error) => {
                let exctatNb = index + 1
                this.$notify({
                  type: 'warning',
                  title: 'Error with tech/sci problem extraction : ' + exctatNb + '/' + documentSearchAllTech.length,
                  placement: 'bottom-right'
                })
              })
          }
        })
      }

      model.startTransaction('search all technoLockIn')
      model.commitTransaction('search all technoLockIn')
    },
    getSvg: function () {
      if (this.biblioContent !== '{}') {
        let svg = this.diagram.makeSvg({
          scale: 1
        })
        let xml = new XMLSerializer().serializeToString(svg)
        return 'data:image/svg+xml;base64,' + btoa(unescape(encodeURIComponent(xml)))
      }
      return null
    },
    undo: function () {
      this.diagram.commandHandler.undo()
    },
    redo: function () {
      this.diagram.commandHandler.redo()
    },
    nodeSpace: function () {
      return $(go.TextBlock, this.textStyle(), {
        row: 1,
        column: 1,
        columnSpan: 4,
        visible: true,
        editable: true,
        isMultiline: false,
        minSize: new go.Size(10, 14),
        margin: new go.Margin(0, 0, 0, 3)
      })
    },
    picto1: function () {
      return $(go.Panel, 'Auto', {
        row: 0,
        column: 0
      }, $(go.Shape, 'Rectangle', {
        fill: this.colors['orange'],
        background: 'transparent',
        cursor: 'help',
        strokeWidth: 0,
        visible: false,
        figure: 'RoundedRectangle',
        height: 20,
        width: 20
      },
      new go.Binding('columnSpan', 'geo_icon', function (icons) {
        icons = icons.split(';')
        return icons.length === 1 ? 1 : 0
      }),
      new go.Binding('geometryString', 'geo_icon', (_icon) => {
        let icons = _icon.split(';')
        return this.geoFunc(icons[0])
      }),
      new go.Binding('visible', 'geo_icon', (_icon) => {
        let icons = _icon.split(';')
        return !!(_icon && icons.length > 1 && icons[0] && icons[0] !== 'empty')
      }))
      )
    },
    picto2: function () {
      return $(go.Panel, 'Auto', {
        row: 1,
        column: 0
      }, $(go.Shape, 'Rectangle', {
        fill: this.colors['orange'],
        background: 'transparent',
        cursor: 'help',
        strokeWidth: 0,
        visible: false,
        figure: 'RoundedRectangle',
        margin: new go.Margin(5, 0, 0, 0),
        height: 0,
        width: 0
      }, new go.Binding('geometryString', 'geo_icon', (icons) => {
        icons = icons.split(';')
        return this.geoFunc(icons[1])
      }),
      new go.Binding('height', 'geo_icon', (icons) => {
        icons = icons.split(';')
        return (icons.length > 1 && icons[1].length !== 0 && icons[1] !== 'empty') ? 20 : 0
      }),
      new go.Binding('width', 'geo_icon', (icons) => {
        icons = icons.split(';')
        return (icons.length > 1 && icons[1].length !== 0 && icons[1] !== 'empty') ? 20 : 0
      }),
      new go.Binding('visible', 'geo_icon', (icons) => {
        icons = icons.split(';')
        return (icons.length > 1 && icons[1].length !== 0 && icons[1] !== 'empty')
      }))
      )
    },
    nodePicto: function () {
      return $(go.Panel, 'Auto', {
        row: 5,
        column: 0,
        visible: false
      },
      new go.Binding('row', 'geo_icon', () => { return 0 }),
      new go.Binding('visible', 'geo_icon', () => { return true }),
      $(go.Panel, 'Table', {
        defaultSeparatorPadding: new go.Margin(0, 2, 0, 2)}, this.picto1(), this.picto2())
      )
    },
    nodeName: function () {
      return $(go.Panel, 'Auto', {
        name: 'title',
        row: 0,
        column: 0,
        columnSpan: 4
      },
      new go.Binding('column', 'geo_icon', function (t) { return 1 }),
      new go.Binding('columnSpan', 'geo_icon', function (t) { return 3 }),
      $(go.TextBlock, this.textStyle(), {
        font: '12pt Segoe UI,sans-serif',
        editable: true,
        isMultiline: true,
        cursor: 'text',
        maxSize: new go.Size(300, 300),
        minSize: new go.Size(200, 0),
        overflow: go.TextBlock.OverflowEllipsis,
        maxLines: 3
      },
      new go.Binding('text', 'name').makeTwoWay(),
      new go.Binding('font', 'searched', (_search) => {
        return (_search) ? '14pt sans-serif' : 'bold 16pt sans-serif'
      }))
      )
    },
    nodeComment: function () {
      return $(go.TextBlock, this.textStyle(), {
        row: 3,
        column: 0,
        columnSpan: 5,
        font: 'italic 9pt sans-serif',
        wrap: go.TextBlock.WrapFit,
        editable: false, // by default newlines are allowed
        minSize: new go.Size(10, 14)
      },
      new go.Binding('text', 'comments').makeTwoWay())
    },
    nodeSearch: function () {
      return $(go.Panel, 'Auto', {
        row: 1,
        column: 0,
        margin: new go.Margin(0, 5, 0, 5)
      },
      $(go.Shape, 'Rectangle', {
        fill: this.colors['white'],
        background: 'transparent',
        cursor: 'pointer',
        strokeWidth: 0,
        figure: 'RoundedRectangle',
        maxSize: new go.Size(25, 25),
        click: (e, obj) => {
          let node = this.diagram.selection.first()
          if (obj.part.data.url !== '(new keyword)' && obj.part.data.name !== '(new keyword)') {
            if (!obj.part.data.searched) {
              let field = 'searched'
              let model = this.diagram.model
              model.startTransaction('modified ' + field)
              model.setDataProperty(node.data, 'searched', true)
              model.commitTransaction('modified ' + field)
            }
            window.location.href = (obj.part.data.url) ? obj.part.data.url : '/search/datas/' + obj.part.data.name
          }
        }
      },
      new go.Binding('geometryString', 'geo_search', this.geoFunc))
      )
    },
    nodeEdit: function () {
      return $(go.Panel, 'Auto', {
        row: 1,
        column: 1,
        margin: new go.Margin(0, 5, 0, 5)
      }, $(go.Shape, 'Rectangle', {
        fill: this.colors['white'],
        background: 'transparent',
        cursor: 'pointer',
        strokeWidth: 0,
        figure: 'RoundedRectangle',
        maxSize: new go.Size(25, 25),
        click: (e, obj) => {
          jQuery(($) => {
            let data = obj.part.data

            let currentColor = (data.color) ? data.color : '#34495e'// keywordObject.color ? keywordObject.color : '#34495e';
            $('select[name="boxColor"]').simplecolorpicker()
            $('select[name="boxColor"]').simplecolorpicker('selectColor', currentColor)
            let icons = (data.geo_icon) ? data.geo_icon : ''
            icons = icons.split(';')
            let selectedIcon1 = icons[0]
            let selectedIcon2 = icons.length > 1 ? icons[1] : ''

            let boxIcon1 = $('#iconSelected1').iconpicker()
              .iconpicker('setCols', 7)
              .iconpicker('setFooter', false)
              .iconpicker('setHeader', false)
              .iconpicker('setIconset', {
                iconClass: 'fas',
                iconClassFix: 'fa-',
                icons: this.icons
              })
              .iconpicker('setPlacement', 'bottom') // Only in button tag
              .iconpicker('setRows', 0)
              .iconpicker('setSearch', false)
              .iconpicker('setSelectedClass', 'btn-danger')
              .iconpicker('setUnselectedClass', 'btn-info btn-outline')
              .on('change', (e) => {
                selectedIcon1 = e.icon
                this.modal.icon = selectedIcon1 + ';' + selectedIcon2
              })
            let boxIcon2 = $('#iconSelected2').iconpicker()
              .iconpicker('setCols', 7)
              .iconpicker('setFooter', false)
              .iconpicker('setHeader', false)
              .iconpicker('setIconset', {
                iconClass: 'fas',
                iconClassFix: 'fa-',
                icons: this.icons
              })
              .iconpicker('setPlacement', 'bottom') // Only in button tag
              .iconpicker('setRows', 0)
              .iconpicker('setSearch', false)
              .iconpicker('setSelectedClass', 'btn-danger')
              .iconpicker('setUnselectedClass', 'btn-info btn-outline')
              .on('change', (e) => {
                selectedIcon2 = e.icon
                this.modal.icon = selectedIcon1 + ';' + selectedIcon2
              })

            this.modal.name = data.name
            this.modal.color = currentColor
            this.modal.searchUrl = data.url ? data.url : '/search/' + data.name
            this.modal.comment = (data.comment) ? data.comment : ''
            this.modal.icon = selectedIcon1 + ';' + selectedIcon2
            this.modal.uploadFiles = $.map(data.uploadFiles, (value, index) => { return [value] })

            $('#boxModal').modal('show')
            setTimeout(() => {
              selectedIcon1 = selectedIcon1 || 'empty'
              selectedIcon2 = selectedIcon2 || 'empty'
              boxIcon1.iconpicker('setIcon', selectedIcon1)
              boxIcon2.iconpicker('setIcon', selectedIcon2)
            }, 900)

            $(document).off('click', '#boxSave')
            $(document).on('click', '#boxSave', (event) => {
              let node = obj.part
              let fileToUpload = 0
              this.modal.uploadFiles.forEach((file) => {
                if (!file.link) {
                  fileToUpload++
                }
              })
              if (!fileToUpload) {
                $('#boxModal').modal('hide')
                let model = this.diagram.model
                // all model changes should happen in a transaction
                model.startTransaction('update box')
                model.setDataProperty(node.data, 'name', this.modal.name)
                model.setDataProperty(node.data, 'url', this.modal.searchUrl)
                model.setDataProperty(node.data, 'color', $('select[name="boxColor"]').val())
                model.setDataProperty(node.data, 'comment', this.modal.comment)
                model.setDataProperty(node.data, 'uploadFiles', Object.assign({}, this.modal.uploadFiles))
                model.setDataProperty(node.data, 'geo_icon', this.modal.icon)
                model.commitTransaction('update box')
              } else {
                this.upload().then((response) => {
                  $('#boxModal').modal('hide')
                  let model = this.diagram.model
                  // all model changes should happen in a transaction
                  model.startTransaction('update box')
                  model.setDataProperty(node.data, 'name', this.modal.name)
                  model.setDataProperty(node.data, 'url', this.modal.searchUrl)
                  model.setDataProperty(node.data, 'color', $('select[name="boxColor"]').val())
                  model.setDataProperty(node.data, 'comment', this.modal.comment)
                  model.setDataProperty(node.data, 'uploadFiles', Object.assign({}, this.modal.uploadFiles))
                  model.setDataProperty(node.data, 'geo_icon', this.modal.icon)
                  model.commitTransaction('update box')
                })
              }
            })
          })
        }
      }, new go.Binding('geometryString', 'geo_edit', this.geoFunc))
      )
    },
    nodeWikipedia: function () {
      return $(go.Panel, 'Vertical', {
        row: 1,
        column: 2,
        margin: new go.Margin(0, 5, 0, 5)
      }, $(go.Shape, {
        fill: this.colors['orange'],
        background: 'transparent',
        cursor: 'pointer',
        visible: false,
        figure: 'RoundedRectangle',
        strokeWidth: 0,
        maxSize: new go.Size(25, 25),
        click: (e, obj) => {
          jQuery(($) => {
            let data = obj.part.data
            this.modalWiki.title = data.name // $(keywordElement).attr('keyword');
            this.modalWiki.description = data.wiki.description
            this.modalWiki.url = data.wiki.url
            $('#modalWiki').modal('show')

            $(document).off('click', '#modalWikiRemove')
            $(document).on('click', '#modalWikiRemove', (event) => {
              event.preventDefault()
              let targetNode = {}
              let _wiki = {
                title: null,
                description: null,
                url: null
              }

              this.diagram.nodes.each((node) => {
                if (node.data.name === data.name) {
                  targetNode = node

                  this.modalWiki.title = null
                  this.modalWiki.description = null
                  this.modalWiki.url = null
                }
              })

              let model = this.diagram.model
              // all model changes should happen in a transaction
              model.startTransaction('modified wiki')
              model.setDataProperty(targetNode.data, 'wiki', _wiki)
              model.commitTransaction('modified wiki')
            })
          })
        }
      },
      new go.Binding('geometryString', 'geo_wiki', this.geoFunc),
      new go.Binding('visible', 'wiki', (_wiki) => {
        return !!(_wiki && _wiki.description)
      })
      ))
    },
    nodeDocuments: function () {
      return $(go.Panel, 'Auto', {
        row: 0,
        column: 0,
        cursor: 'pointer'
      },
      $(go.TextBlock, {
        stroke: this.colors['orange'],
        textAlign: 'center',
        text: '0',
        font: '13pt  Segoe UI,sans-serif',
        click: (e, obj) => {
          this.initDocumentsModal(e, obj, 'scienceDoc')
        }
      }, new go.Binding('text', 'documents', (_docs) => {
        let nb = 0
        if (_docs && typeof _docs === 'object' && Object.keys(_docs).length) {
          nb = Object.keys(_docs).length
          Object.values(_docs).forEach((doc) => {
            if (doc.type && (doc.type === 'patents' || doc.type === 'company' || doc.type === 'news')) nb--
          })
        }
        return nb
      })
      ))
    },
    nodePatents: function () {
      return $(go.Panel, 'Auto', {
        row: 0,
        column: 1
      },
      $(go.TextBlock, {
        stroke: this.colors['orange'],
        textAlign: 'center',
        text: '0',
        font: '13pt  Segoe UI,sans-serif',
        click: (e, obj) => {
          this.initDocumentsModal(e, obj, 'patentDoc')
        }
      },
      new go.Binding('text', 'documents', (_docs) => {
        let nb = 0
        if (_docs && typeof _docs === 'object' && Object.keys(_docs).length) {
          Object.values(_docs).forEach((doc) => {
            if (doc.type && (doc.type === 'patents' || doc.type === 'company')) nb++
          })
        }
        return nb
      })
      ))
    },
    nodeNews: function () {
      return $(go.Panel, 'Auto', {
        row: 0,
        column: 2,
        cursor: 'pointer'
      },
      $(go.TextBlock, {
        stroke: this.colors['orange'],
        textAlign: 'center',
        text: '0',
        font: '13pt  Segoe UI,sans-serif',
        click: (e, obj) => {
          this.initDocumentsModal(e, obj, 'newsDoc')
        }
      }, new go.Binding('text', 'documents', (_docs) => {
        let nb = 0
        if (_docs && typeof _docs === 'object' && Object.keys(_docs).length) {
          Object.values(_docs).forEach((doc) => {
            if (doc.type && doc.type === 'news') nb++
          })
        }
        return nb
      })
      ))
    },
    nodeUploadFiles: function () {
      return $(go.Panel, 'Auto', {
        row: 0,
        column: 3,
        visible: true
      },
      $(go.TextBlock, {
        stroke: this.colors['orange'],
        maxSize: new go.Size(20, 20),
        textAlign: 'center',
        text: '+',
        font: '13pt  Segoe UI,sans-serif',
        click: (e, obj) => {
          this.initDocumentsModal(e, obj, 'externalFile')
        }
      },
      new go.Binding('text', 'uploadFiles', (uploadFiles) => {
        return (uploadFiles && typeof uploadFiles === 'object' && Object.keys(uploadFiles).length) ? Object.keys(uploadFiles).length : '+'
      })
      ))
    },
    nodeDisplayDocuments: function () {
      return $(go.Panel, 'Auto', {
        row: 1,
        column: 3,
        cursor: 'pointer',
        alignment: go.Spot.Right
      },
      $(go.Shape, {
        fill: 'transparent',
        background: 'transparent',
        cursor: 'pointer',
        strokeWidth: 1,
        stroke: 'white',
        figure: 'Rectangle'
      }),
      $(go.Panel, 'Table', {
        defaultSeparatorPadding: new go.Margin(3, 5, 3, 5)

      },
      this.nodeDocuments(),
      $(go.RowColumnDefinition,
        { column: 1, separatorStrokeWidth: 1, separatorStroke: 'white' }),
      this.nodePatents(),
      $(go.RowColumnDefinition,
        { column: 2, separatorStrokeWidth: 1, separatorStroke: 'white' }),
      this.nodeNews(),
      $(go.RowColumnDefinition,
        { column: 3, separatorStrokeWidth: 1, separatorStroke: 'white' }),
      this.nodeUploadFiles()
      ))
    },
    nodeTooltip () {
      return $(go.Adornment, 'Auto',
        $(go.Shape, { fill: 'lightyellow' }),
        $(go.Panel, 'Vertical',
          $(go.TextBlock, { margin: 3 },
            new go.Binding('text', 'comment', function (s) { return s || null }))
        )
      )
    },
    nodeCollapse: function () {
      return $('TreeExpanderButton', {
        width: 15,
        height: 15,
        'ButtonIcon.stroke': 'black',
        'ButtonBorder.fill': 'white',
        'ButtonBorder.stroke': 'transparent',
        alignment: go.Spot.TopRight,
        alignmentFocus: go.Spot.Center,
        click: (e, obj) => {
          let node = obj.part

          if (node.isTreeExpanded) {
            node.collapseTree(1)
          } else {
            node.expandTree(this.diagram.nodes.count)
          }

          let model = this.diagram.model

          model.startTransaction('update collapsed')
          this.diagram.nodes.each((node) => {
            model.setDataProperty(node.data, 'isExpanded', node.isTreeExpanded)
          })
          model.commitTransaction('update collapsed')
        }
      })
    },
    tablePanel: function () {
      return $(go.Panel, 'Table', {
        margin: new go.Margin(10, 10, 10, 10),
        background: 'transparent',
        cursor: 'move',
        defaultSeparatorPadding: new go.Margin(5, 0, 5, 0)
      },
      this.nodePicto(),
      this.nodeName(),
      this.nodeEdit(),
      this.nodeSearch(),
      this.nodeWikipedia(),
      this.nodeDisplayDocuments()
      )
    },
    addDocumentToBiblio: function (document, boxName = null) {
      let boxUrl = '/search/' + boxName
      let biblioId = this.$parent.biblio.id
      let listType = this.getSearchType()
      this.$requestStack.add('post', '/biblio/' + biblioId + '/add/document', {
        url: boxUrl,
        name: boxName,
        document_id: document.documentID,
        document_dt: document.pubDate,
        document_title: document.title,
        document_source: document.publication,
        document_link: document.link,
        document_type: listType,
        document_authors: document.co_authors.map((author) => {
          return author.lastName + ' ' + author.firstName
        }).join(', '),
        document_abstract: document.abstract,
        document_doi: document.doi,
        document_authors_details: JSON.stringify(document.co_authors),
        isCopyTo: true
      }, 0).then((response) => {
        this.$eventHub.$emit('refreshBiblio', true)
        this.$notify({
          type: 'success',
          title: 'Document added to Biblio',
          placement: 'bottom-right'
        })
        this.$salesMachine.addDocToBiblio({document: document})
        this.diagram.commitTransaction('add document to biblio')
      })
        .catch((error) => {
          this.$notify({
            type: 'danger',
            title: 'An error has occurred',
            content: 'We are sorry but we encountered an error, please refresh your page or contact support!',
            placement: 'bottom-right'
          })
        })
    },
    addAiChatToBiblio: function (aichatComment, keywordId = null) {
      if (!keywordId) {
        keywordId = this.query.split(',')
        keywordId = keywordId[keywordId.length - 1].replace(/[\.,'\/#!?|$%\^"&\*;:{><}=\_`~(),]/g, '')
      }
      keywordId = keywordId.toLowerCase().replace(/\s/g, '')
      let model = this.diagram.model
      this.diagram.nodes.each((node) => {
        let name = node.data.name.toLowerCase().replace(/\s/g, '')
        if (name === keywordId) {
          node.data.comment = node.data.comment ? node.data.comment + '\n' + aichatComment : aichatComment
          model.startTransaction('add AiChat comment to box')
          model.setDataProperty(node.data, 'comment', node.data.comment)
          model.commitTransaction('update box')
        }
      })
    },
    getSearchType: function () {
      let typeSearched = this.$route.query.typeSearched
      if (!typeSearched) return 'science'
      switch (typeSearched.toString()) {
        case '0':
          return 'science'
          break
        case '1':
          return 'patents'
          break
        case '3':
          return 'company'
          break
        case '4':
          return 'news'
          break
      }
    },
    summarize: function (node) {
      let documents = node.documents
      const docsArray = Object.values(documents)
      let result = this.promptSummarize
      docsArray.forEach((doc) => {
        result += 'Title : ' + doc.title + '\n' + 'Abstract : ' + doc.abstract.replace(/<img[^>]*src="data:image[^"]*"[^>]*>/g, '') + '\n' + 'Author : ' + doc.authors + '\n' + 'Date : ' + doc.dt + '\n \n'
      })
      this.$notify({
        type: 'success',
        title: 'Summarization in progress ...',
        placement: 'bottom-right'
      })
      this.axios.post('/search/chatai/prompt', {prompt: result})
        .then((response) => {
          if (response.data) {
            let resp = response.data.aichat
            if (resp) {
              let model = this.diagram.model
              let comment = node.comment + '\n' + resp
              model.startTransaction('change Summarize')
              model.setDataProperty(node, 'comment', comment)
              model.setDataProperty(node, 'summarize', resp)
              model.commitTransaction('change Summarize')
            }
          }
        })
        .catch((_error) => {
          this.$notify({
            type: 'warning',
            title: 'Error with AI execution query please edit or try again',
            placement: 'bottom-right'
          })
        })
    },
    summarizeAll: function (nodes, parentNode) {
      let result = this.promptSummarize
      nodes.forEach((node) => {
        let documents = node.data.documents
        if (documents && typeof documents === 'object') {
          const docsArray = Object.values(documents)
          docsArray.forEach((doc) => {
            result += 'Title : ' + doc.title + '\n' + 'Abstract : ' + doc.abstract.replace(/<img[^>]*src="data:image[^"]*"[^>]*>/g, '') + '\n' + 'Author : ' + doc.authors + '\n' + 'Date : ' + doc.dt + '\n \n'
          })
        }
      })
      this.$notify({
        type: 'success',
        title: 'Summarization in progress',
        placement: 'bottom-right'
      })
      this.axios.post('/search/chatai/prompt', {prompt: result})
        .then((response) => {
          if (response.data) {
            let resp = response.data.aichat
            if (resp) {
              let model = this.diagram.model
              let comment = parentNode.comment + '\n' + resp
              model.startTransaction('change summarizeNodes')
              model.setDataProperty(parentNode, 'summarizeNodes', resp)
              model.setDataProperty(parentNode, 'comment', comment)
              model.commitTransaction('change summarizeNodes')
            }
          }
        })
        .catch((_error) => {
          this.$notify({
            type: 'warning',
            title: 'Error with AI execution query please edit or try again',
            placement: 'bottom-right'
          })
        })
    },
    selectDescendants: function (node) {
      var self = this
      if (node === null) return
      node.findTreeChildrenNodes().each((child) => {
        child.isSelected = true
        self.selectDescendants(child)
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/biblio/BiblioGoJs.vue